// DeadMansSwitch — stubbed for Seitiate+ v1.
import { useState } from 'react';

export function DeadMansSwitch() {
  const [armed] = useState(false);
  return (
    <div className="bg-gray-900/20 border border-gray-800 rounded-lg p-3">
      <h3 className="text-xs font-mono text-gray-500 mb-2 uppercase">Dead Man&apos;s Switch</h3>
      <div className="flex items-center gap-2">
        <span className={`w-2 h-2 rounded-full ${armed ? 'bg-red-500' : 'bg-green-500'}`} />
        <span className="text-xs font-mono text-gray-400">
          {armed ? 'ARMED' : 'NOMINAL'}
        </span>
      </div>
    </div>
  );
}
